import { createAction } from '../../utils/redux'
import { ActionsUnion } from '../../utils/types'
import { Profile, ProfileValidationParameters, ProfileValidationResult, ProfileSearchParameters } from './types'

// actions
export const SET_SEARCH = 'profile/SET_SEARCH'

export const FETCH_PROFILES = 'profile/FETCH_PROFILES'
export const FETCH_PROFILES_SUCCESS = 'profile/FETCH_PROFILES_SUCCESS'

export const FETCH_PROFILE_INFO = 'profile/FETCH_PROFILE_INFO'
export const FETCH_PROFILE_INFO_SUCCESS = 'profile/FETCH_PROFILE_INFO_SUCCESS'
export const FETCH_PROFILE_INFO_ERROR = 'profile/FETCH_PROFILE_INFO_ERROR'

export const START_PROFILE_VALIDATION = 'profile/START_PROFILE_VALIDATION'
export const UPDATE_PROFILE_VALIDATION = 'profile/UPDATE_PROFILE_VALIDATION'

export const UPDATE_SELECTED_PROFILE = 'profile/UPDATE_SELECTED_PROFILE'

export const START_SAVING_PROFILE = 'profile/START_SAVING_PROFILE'
export const SAVING_PROFILE_SUCCESS = 'profile/SAVING_PROFILE_SUCCESS'
export const SAVING_PROFILE_FAIL = 'profile/SAVING_PROFILE_FAIL'

export const ProfileActions = {
  // ALL PROFILES
  fetchAllProfiles: (
    limit: number,
    offset: number,
    sid: string,
    appearance: string,
    age: string,
    hair: string,
    breast: string,
    skin: string,
    size: string
  ) => createAction(FETCH_PROFILES, { limit, offset, sid, appearance, age, hair, breast, skin, size }),
  fetchProfilesSuccess: (profile: Profile[], count: number) => createAction(FETCH_PROFILES_SUCCESS, { profile, count }),
  // SINGLE PROFILE
  fetchProfileInfo: (sid: string, profileId: number) => createAction(FETCH_PROFILE_INFO, { sid, profileId }),
  fetchProfileInfoSuccess: (profile: ProfileValidationParameters) => createAction(FETCH_PROFILE_INFO_SUCCESS, profile),
  // VALIDATION
  startProfileValidation: (profile: ProfileValidationParameters) => createAction(START_PROFILE_VALIDATION, { profile }),
  updateProfileValidation: (result: ProfileValidationResult) => createAction(UPDATE_PROFILE_VALIDATION, result),
  // SAVING
  startSavingProfile: (profile: ProfileValidationParameters) => createAction(START_SAVING_PROFILE, { profile }),
  savingProfileSuccess: (profile: Profile) => createAction(SAVING_PROFILE_SUCCESS, profile),
  // SELECTED PROFILE
  updateSelectedProfile: (profile: ProfileValidationParameters | null) =>
    createAction(UPDATE_SELECTED_PROFILE, profile),
  // SEARCH PARAMETERS
  setSearch: (search: ProfileSearchParameters) => createAction(SET_SEARCH, search)
}

export type ProfileActions = ActionsUnion<typeof ProfileActions>
